// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","brand":"Footer_brand__QKAvM","links":"Footer_links__wMgLO","bottomBar":"Footer_bottomBar__O-fPK"};